module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_trollhattan-024f781411be351432a01d7693b5c35e.png";